import React, { useState } from "react"
import clsx from "clsx"

import { Link } from "../../link"

function Breadcrumb({
  label = "Breadcrumb",
  href = "/",
  appearance = "primary",
}) {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <div data-component="Breadcrumb" className="leading-normal cap-subtitle">
      <Link
        className={clsx(
          "inline border-b border-opacity-0 transition-colors ease-out duration-150",
          isHovering === true && "border-opacity-100",
          appearance === "primary" && "border-violet text-violet",
          appearance === "secondary" && "border-gold text-gold"
        )}
        href={href}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        {label}
      </Link>
    </div>
  )
}

export default Breadcrumb
